import {
  cloneElement,
  forwardRef,
  HTMLAttributes,
  isValidElement,
  ReactElement,
} from "react";
import { Tooltip } from "antd";
import { useIsViewer } from "../../hooks/useIsViewer";

export const viewerTooltipMessage = "Read-only viewers can't do this";

type Props = HTMLAttributes<HTMLElement> & {
  children: ReactElement<{ disabled?: boolean }>;
};

/** Disables a single form control/button and explains why when the current
 * identity is a read-only viewer; renders children unchanged otherwise.
 *
 * Stays transparent to overlay triggers (Popconfirm, Dropdown) that reach their
 * control by cloning it. */
export const DisableForViewer = forwardRef<HTMLElement, Props>(
  ({ children, ...triggerProps }, ref) => {
    const isViewer = useIsViewer();
    if (!isValidElement(children)) {
      return children;
    }
    if (!isViewer) {
      return cloneElement(children as ReactElement<Record<string, unknown>>, {
        ...triggerProps,
        ref,
      });
    }
    return (
      <Tooltip title={viewerTooltipMessage}>
        <span>{cloneElement(children, { disabled: true })}</span>
      </Tooltip>
    );
  },
);

DisableForViewer.displayName = "DisableForViewer";
